import { useMemo } from 'react';
import { getTimeFromNow } from '../utils/dateTime';

export function useRelativeTime(date: string | undefined | null) {
  const relative = useMemo(() => {
    if (!date) return '';
    return getTimeFromNow(date);
  }, [date]);

  return relative;
} 